import React from 'react';

// import 'rc-calendar/assets/index.css';
import PropTypes from 'prop-types';

import RCCalendar from 'rc-calendar';
import DatePicker from 'rc-calendar/lib/Picker';
import moment from "moment"
import { getStyleTag } from '../../styles/dynamicStyles'

// Default all 2 year dates to the 1900s
moment.parseTwoDigitYear = function(yearString) {
  return parseInt(yearString) + 1900;
}

if (typeof window !== 'undefined'){
  require('rc-calendar/assets/index.css');
}

export default class Calendar extends React.Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    inputProps: PropTypes.object,
    calenderProps: PropTypes.object,
    pickerProps: PropTypes.object,
    format: PropTypes.array,
    name: PropTypes.string,
  }

  static defaultProps = {
    format: ['DD/MM/YYYY', 'DD/MM/YY', 'DDMMYY', 'YYYY', 'D/M/YYYY', 'D/M/YY'],
    name: 'calendar',
    placeholder: 'Please select'
  }

  getCalendarContainer(props) {
    return document.getElementById('calendar-dom-hook');
  }

  render() {
    const {format, onChange, value, calenderProps, pickerProps} = this.props

    const calendar = <RCCalendar
      format={format}
      defualtValue={value || undefined}
      {...calenderProps}
    />;

    return (
      <div>
        {getStyleTag(['rc-calendar'])}
        <DatePicker
          calendar={calendar}
          onChange={onChange}
          value={value || undefined}
          getCalendarContainer={this.getCalendarContainer}
          {...pickerProps}
        >
          {this.renderInput}
        </DatePicker>
      </div>
    )
  }

  renderInput = ({value}) => {
    const {format, placeholder, inputProps, name} = this.props
    const dvalue = value || this.props.value || null

    return (
      <span tabIndex="0">
        <input
          name={name}
          type="text"
          placeholder={placeholder}
          readOnly
          tabIndex="-1"
          className="ant-calendar-picker-input ant-input"
          value={dvalue ? moment(dvalue, format).format('DD/MM/YYYY') : ""}
          {...inputProps}
        />
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./webapp/components/elements/Calendar.js